export class ManageReleaseRequest {
    releaseId: number;
    releaseVersion: string;
    displayName: string;
    rmReleaseId: number;
    productId: number;
    releaseGADate: Date | string;
    releasePublishDate: Date | string;
    isActive: boolean;
    description: string;
    updatedBy: string;
}



// WEBPACK FOOTER //
// ./src/app/models/update-release-request.ts